import { clsx } from "clsx";
import type { SVGProps } from "react";
const SvgTripsError = ({ className, ...props }: SVGProps<SVGSVGElement>) => {
  const mergedClassName = clsx("rtl:-scale-x-100", className);
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={60}
      height={60}
      fill="none"
      aria-hidden="true"
      className={mergedClassName}
      {...props}
    >
      <path
        stroke="#96979A"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2.5}
        d="M47.5 45.834s-7.5-5-17.5-5c-8.333 0-12.5 3.333-16.667 5.833m25 1.428s-3.293-1.428-7.683-1.428c-3.659 0-5.488.952-7.317 1.666m12.503-31.662s-5 3.328-6.666 8.334M37.5 17.5s2.5 5.832.836 10.002"
      />
      <path
        stroke="#96979A"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2.5}
        d="M36.494 16.325c-5.589-1.31-11.27 1.585-13.808 6.657-.527 1.054-.791 1.58-.458 2.06.333.478.985.414 2.289.285l2.907-.285c.437-.043.872.059 1.24.29l4.807 3.028 5.709-.561a1.96 1.96 0 0 1 1.239.29l2.508 1.58c1.076.677 1.614 1.016 2.116.754.503-.262.522-.832.561-1.972.195-5.669-3.49-10.808-9.11-12.126M34.241 28.85l-2.575 11.983m4.865-24.723.001-1.11"
      />
      <rect width={20} height={20} x={32} y={32} fill="#fff" rx={10} />
      <path fill="#D9D9D9" d="m46 38-8 8zm0 8-8-8z" />
      <path
        stroke="#DE370C"
        strokeLinecap="round"
        strokeWidth={2}
        d="m46 38-8 8m8 0-8-8"
      />
    </svg>
  );
};
export default SvgTripsError;
